import {useEffect} from 'react';
import {ICustomerResponse} from 'types';

const useUtmTelegram = (customer: ICustomerResponse, isLoadingGetting: boolean) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (isLoadingGetting) return;
    const url = window?.location?.href;
    const referrer = document?.referrer;
    if (referrer && !referrer.includes('straus.md')) {
      localStorage.setItem('referrer', referrer);
    }

    if (!url.includes('utm_')) return;
    const urlLastPath = url.split('/').pop();

    const storedUrl = localStorage.getItem('utm_url_source');
    if (storedUrl?.split('/').pop() !== url.split('/').pop()) {
      localStorage.setItem('utm_url_source', `${urlLastPath}`);
    }
  }, [customer, isLoadingGetting]);
};

export default useUtmTelegram;
